import { CUSTOM_FIELD_VALUE_TYPES } from '@vy/custom-fields-types';
import type { CustomFieldDefinition } from '@vy/custom-fields-types';
import { MONGO_FILTER_OPERATORS } from '@vy/types';
import type { FilterField } from '../components/new-design/vyTableFilter';

const CUSTOM_FIELD_TYPE_CONFIG: Record<
  string,
  { inputType: FilterField['inputType']; operators: FilterField['operators'] }
> = {
  [CUSTOM_FIELD_VALUE_TYPES.STRING]: {
    inputType: 'text',
    operators: [{ label: 'Contains', value: MONGO_FILTER_OPERATORS.REGEX }],
  },
  [CUSTOM_FIELD_VALUE_TYPES.NUMBER]: {
    inputType: 'number',
    operators: [
      { label: 'Equals', value: MONGO_FILTER_OPERATORS.EQUALS },
      { label: 'Greater than', value: MONGO_FILTER_OPERATORS.GREATER_THAN },
      { label: 'Less than', value: MONGO_FILTER_OPERATORS.LESS_THAN },
    ],
  },
  [CUSTOM_FIELD_VALUE_TYPES.BOOLEAN]: {
    inputType: 'boolean',
    operators: [{ label: 'Is', value: MONGO_FILTER_OPERATORS.EQUALS }],
  },
  [CUSTOM_FIELD_VALUE_TYPES.ENUM]: {
    inputType: 'select',
    operators: [
      { label: 'Is any of', value: MONGO_FILTER_OPERATORS.IN },
      { label: 'Is not any of', value: MONGO_FILTER_OPERATORS.NOT_IN },
    ],
  },
};

const DEFAULT_CONFIG = CUSTOM_FIELD_TYPE_CONFIG[CUSTOM_FIELD_VALUE_TYPES.STRING];

export function customFieldDefinitionToFilterField(
  definition: CustomFieldDefinition,
  fieldId: string,
): FilterField {
  const { inputType, operators } = CUSTOM_FIELD_TYPE_CONFIG[definition.valueType] ?? DEFAULT_CONFIG;
  return {
    id: fieldId,
    label: definition.vayuCustomFieldName,
    inputType,
    operators,
    options:
      definition.valueType === CUSTOM_FIELD_VALUE_TYPES.ENUM
        ? (definition.allowedValues ?? []).map((v) => ({ value: v, label: v }))
        : undefined,
  };
}
